module.exports = __webpack_public_path__ + "static/img/17.7600fa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/17.png
// module id = W+De
// module chunks = 0